import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const FOCUS_OUTLINE_WIDTH = 2;

/** @deprecated Use focus instead of this focus style, which aligns more with design */
export const focusBorderOld = css`
  border: var(--brand-bluple-base) ${pxToRem(FOCUS_OUTLINE_WIDTH)} solid;
`;

/** @deprecated Use focus instead of this focus style, which aligns more with design */
export const focusOld = css`
  box-shadow: none;
  ${focusBorderOld};
`;

export const focus = css`
  -webkit-box-shadow: 0 0 0 ${pxToRem(2)} var(--neutral-white-base),
    0 0 0 ${pxToRem(4)} var(--brand-bluple-base);
  box-shadow: 0 0 0 ${pxToRem(2)} var(--neutral-white-base),
    0 0 0 ${pxToRem(4)} var(--brand-bluple-base);
`;

export const highContrastFocus = css`
  -webkit-box-shadow: 0 0 0 ${pxToRem(3)} var(--neutral-white-base),
    0 0 0 ${pxToRem(6)} var(--brand-bluple-base);
  box-shadow: 0 0 0 ${pxToRem(3)} var(--neutral-white-base),
    0 0 0 ${pxToRem(6)} var(--brand-bluple-base);
`;
